import request from '@/utils/request'
const context = require('./context')

export function fetchDockedInfo() {
    return request({
        url: context.EEOP + '/aiActionDocked/load',
        method: 'get'
    })
}

export function createDocked(data) {
    return request({
        url: context.EEOP + '/aiActionDocked/createDocked',
        method: 'post',
        data: data
    })
}

export function delDocked(data) {
    return request({
        url: context.EEOP + '/aiActionDocked/delete/'+data,
        method: 'post'
    })
}

export function fetchDishesCateList() {
	return request({
		url: context.EEOP + '/meals/dishes_cate_list',
		method: 'get'
	})
}
export function fetchCompositionList(data) {
	return request({
			url: context.EEOP + '/meals/meals_composition_list/'+data,
			method: 'get'
	})
}

export function fetchCompositionGroup(data) {
	return request({
			url: context.EEOP + '/meals/meals_composition_group',
			method: 'get',
			params: data
	})
}

export function saveCompositionGroup(data) {
	return request({
		url: context.EEOP + '/meals/save_composition',
		method: 'post',
		data: data
	})
}

export function deleteMealsSetGroup(id) {
	return request({
	  url: context.EEOP + '/meals/delete/' + id,
	  method: 'post'
	})
}

export function fetchNutritionBalanceList() {
	return request({
		url: context.EEOP + '/nutrition_balance/list',
		method: 'get',
	})
}

export function saveNutritionBalance(params) {
	return request({
		url: context.EEOP + '/nutrition_balance/save',
		method: 'POST',
		data: params
	})
}

export function removeNutritionBalance(params) {
	return request({
		url: context.EEOP + '/nutrition_balance/delete/'+params,
		method: 'POST'
	})
}

export function saveNotUseIngredient(params) {
	return request({
		url: context.EEOP + '/meals/save_not_use_ingredient',
		method: 'POST',
		data: params
	})
}

export function queryNotUseIngredientList(params) {
	return request({
		url: context.EEOP + '/meals/query_not_use_ingredient/'+params,
		method: 'get',
	})
}

export function removeNotUseIngredient(params) {
	return request({
		url: context.EEOP + '/meals/delete_not_use_ingredient/'+params,
		method: 'POST'
	})
}



// WEBPACK FOOTER //
// ./src/api/aicenter.js